import { useCallback } from 'react';
import { useRouter } from 'expo-router';

import { useIsNavigationReady } from '@sg/garnish';

/**
 * Goes back within the stack if possible, otherwise goes back to the main stack.
 */
export const useNavigateBack = () => {
  const router = useRouter();
  const isNavigationReady = useIsNavigationReady();

  return useCallback(() => {
    requestIdleCallback(() => {
      if (!isNavigationReady) return;

      setTimeout(() => {
        if (router.canGoBack()) {
          router.back();

          return;
        }

        router.dismissTo('/');
      });
    });
  }, [isNavigationReady, router]);
};
